import { Component, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, ContentService, EventBusService, ExchangeService, UserService } from "@mypxplat/xplat/core";
import { AppService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { ClipboardService } from "ngx-clipboard";
import { take } from "rxjs";
import { AddEditProductSplashComponent } from "../../modals";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-approve-exchange-assets",
  templateUrl: "approve-exchange-assets.component.html",
  standalone: false,
})
export class ApproveExchangeAssetsComponent extends BaseComponent {
  public wares: any;
  public limit: number = 25;
  constructor(
    userService: UserService,
    public appService: AppService,
    public contentService: ContentService,
    public evenbusService: EventBusService,
    public communityService: WebCommunityService,
    public exchangeService: ExchangeService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.exchangeService.getUnapprovedWares(this.limit, 1).subscribe((result) => {
      this.wares = result;
    });
  }

  viewExchangeDetail(id) {
    window.open(this.env.fenderUrl + "exchange/detail/" + id, "_blank");
  }
}
